(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDocumentTemplateEditorTxt', drvDocumentTemplateEditorTxt);

    /**
     * @ngdoc directive
     * @name drvDocumentTemplateEditorTxt
     *
     * @description
     * Editor for TXT / plain-text document template.
     *
     * # Scope Properties
     * {string} value
     * {DocumentTemplate} documentTemplate
     * {TestMerge} testMerge
     * {bool} readonly
     */
    function drvDocumentTemplateEditorTxt() {
        return {
            templateUrl: 'app/documenttemplate/document-template-editor-txt.tmpl.html',
            require: 'ngModel',
            scope: {
                value: '=ngModel',
            },
            controller: DocumentTemplateEditorTxtCtrl,
            controllerAs: 'drvCtrl',
            bindToController : {
                value: '=ngModel',
                documentTemplate: '<',
                testMerge: '<',
                readonly: '<?',
                entityTemplate: '<'
            }
        };
    }

    DocumentTemplateEditorTxtCtrl.$inject = ['$element', 'FieldSelectorService', 'DialogService'];

    function DocumentTemplateEditorTxtCtrl($element, FieldSelectorService, DialogService) {
        var drvCtrl = this;
        drvCtrl.insertField = insertField;

        /*
         * Opens the field selector dialog and adds the field reference to the text area.
         *
         */
        function insertField() {
            if (!_.isNil(drvCtrl.entityTemplate)) {
                FieldSelectorService.displayDialogForEntityTemplate(drvCtrl.entityTemplate, {
                    includeOrganisation: true,
                    includeCurrentUser: true,
                    includeDocumentTemplate: true,
                    includeFileDetails: true,
                    includeEntitySystem: true
                }).then(function (data) {
                    if (!_.isNil(data) && !_.isNil(data[0])) {
                        var textareaElement = $element[0].querySelector('textarea');

                        drvCtrl.value = drvCtrl.value.substring(0, textareaElement.selectionStart) + data + drvCtrl.value.substring(textareaElement.selectionStart, drvCtrl.value.length);
                    }
                });
            } else {
                DialogService.alert('Entity Template must be selected before Insert Field can be used');
            }
        }
    }
})();